import { render, staticRenderFns } from "./formG.vue?vue&type=template&id=35f13108&scoped=true&"
import script from "./formG.vue?vue&type=script&lang=js&"
export * from "./formG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f13108",
  null
  
)

export default component.exports